import { render, staticRenderFns } from "./LoginInitializeView.vue?vue&type=template&id=bb511f94&scoped=true"
import script from "./LoginInitializeView.vue?vue&type=script&lang=js"
export * from "./LoginInitializeView.vue?vue&type=script&lang=js"
import style0 from "./LoginInitializeView.vue?vue&type=style&index=0&id=bb511f94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb511f94",
  null
  
)

export default component.exports